(function ($) {
	/**
	 * Office Location dropdown on Contact Page
	 */
	$('.select-office').select2({
		minimumResultsForSearch: Infinity
	});

	$(document.body).on("change", ".select-office", function(){
		if(this.value!='0'){
			window.location.href = this.value;
		}
	});

	/**
	 * Project Type dropdown on Projects Page
	 */
	$('.select-project-type').select2({
		minimumResultsForSearch: Infinity,
		dropdownCssClass: "project-type-dropdown",
	});

	$(document.body).on("change", ".select-project-type", function(){
		if(this.value!='0'){
			window.location.href = this.value;
		}
	});

	/**
	 * News Categories dropdown on News Page
	 */
	$('.select-news-category').select2({
		minimumResultsForSearch: Infinity,
		dropdownCssClass: "categories-dropdown",
	});

	$(document.body).on("change", ".select-news-category", function(){
		if(this.value!='0'){
			window.location.href = this.value;
		}
	});

	/**
	 * Reason dropdown on contact form
	 */
	$('.select-reason').select2({
		minimumResultsForSearch: Infinity,
		placeholder: "SUBJECT",
		dropdownCssClass: "cf7-dropdown",
	});
	
	/**
	 * Generic select fields
	 */
	$('.select-generic').select2({
		minimumResultsForSearch: Infinity,
		dropdownCssClass: "cf7-dropdown",
	});
})(jQuery);
